import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeDividendTypeMapping  {
    _originalTypeClassName = "zERP.BO.BackOfficeDividendTypeMapping";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeDividendTypeMapping.translate = translateService;
}
this.DividentLineMappings = [];
this.TaxLineMappings = [];
this.Id = null;
this.BackofficeId = null;
this.BackofficeDescription = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
BackofficeId:any;
BackofficeDescription:any;
DividentLineMappings:any;
TaxLineMappings:any;
static setDividentLineMappings = ($this, items) => {
                if (items == null) items = [];
                if ($this.DividentLineMappings == null) $this.DividentLineMappings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DividentLineMappings.length > 0) {
                    Domain.BackOfficeDividendTypeMapping.removeDividentLineMappings($this, $this.DividentLineMappings[0]);
                }

                Domain.BackOfficeDividendTypeMapping.addManyDividentLineMappings($this, copyItems);
            }
static addManyDividentLineMappings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BackOfficeDividendTypeMapping.addDividentLineMappings($this, items[i]);
                }
            }
static addDividentLineMappings = ($this, item) => {
                if ($this.DividentLineMappings == null) $this.DividentLineMappings = [];
                if (item == null || $this.DividentLineMappings.indexOf(item) > -1) return;
                $this.DividentLineMappings.push(item);
}
static addRangeDividentLineMappings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BackOfficeDividendTypeMapping.addDividentLineMappings($this, item));
            }
static removeDividentLineMappings = ($this, item) => {
                if ($this == null || $this.DividentLineMappings == null || $this.DividentLineMappings.indexOf(item) === -1) return;
                var _index = $this.DividentLineMappings.indexOf(item);
                $this.DividentLineMappings.splice(_index, 1);
}
static clearDividentLineMappings = ($this) => { $this.DividentLineMappings = null; }
static setTaxLineMappings = ($this, items) => {
                if (items == null) items = [];
                if ($this.TaxLineMappings == null) $this.TaxLineMappings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TaxLineMappings.length > 0) {
                    Domain.BackOfficeDividendTypeMapping.removeTaxLineMappings($this, $this.TaxLineMappings[0]);
                }

                Domain.BackOfficeDividendTypeMapping.addManyTaxLineMappings($this, copyItems);
            }
static addManyTaxLineMappings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BackOfficeDividendTypeMapping.addTaxLineMappings($this, items[i]);
                }
            }
static addTaxLineMappings = ($this, item) => {
                if ($this.TaxLineMappings == null) $this.TaxLineMappings = [];
                if (item == null || $this.TaxLineMappings.indexOf(item) > -1) return;
                $this.TaxLineMappings.push(item);
}
static addRangeTaxLineMappings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BackOfficeDividendTypeMapping.addTaxLineMappings($this, item));
            }
static removeTaxLineMappings = ($this, item) => {
                if ($this == null || $this.TaxLineMappings == null || $this.TaxLineMappings.indexOf(item) === -1) return;
                var _index = $this.TaxLineMappings.indexOf(item);
                $this.TaxLineMappings.splice(_index, 1);
}
static clearTaxLineMappings = ($this) => { $this.TaxLineMappings = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}